import { configureStore } from '@reduxjs/toolkit';
import shoppingCartReducer from './reducers/shoppingCartReducer';
import pickupReducer from './reducers/pickupReducer';
import tabReducer from './reducers/tabsReducer';
import appLoaderReducer from './reducers/appLoaderReducer';
import customerReducer from './reducers/customerReducer';
import sideBarReducer from './reducers/sideBarReducer';
import authReducer from './reducers/authReducer';
import linksReducer from './reducers/linksReducer';
import categoriesReducer from './reducers/categoriesReducer';
import settingsReducer from './reducers/settingsReducer';

export const store = configureStore({
  reducer: {
    shoppingCartState: shoppingCartReducer,
    pickupState: pickupReducer,
    tabState: tabReducer,
    appLoaderState: appLoaderReducer,
    customerState: customerReducer,
    sideBarState: sideBarReducer,
    authState: authReducer,
    linksState: linksReducer,
    categoriesState: categoriesReducer,
    settingsState: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: false,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
